export const POSITIONS = [
  "حارس مرمى",
  "قلب دفاع",
  "ظهير أيمن",
  "ظهير أيسر",
  "وسط دفاعي",
  "وسط",
  "وسط هجومي",
  "جناح أيمن",
  "جناح أيسر",
  "مهاجم",
];

export const FEET = ["اليمنى", "اليسرى", "كلتاهما"];

export const ROLE_LABELS = {
  admin: "مدير النظام",
  coach: "مدرب",
  assistant_coach: "مساعد مدرب",
  goalkeeper_coach: "مدرب حراس",
};

export const ATTENDANCE = {
  present: "حاضر",
  absent: "غائب",
  late: "متأخر",
};

// Vertical pitch, x = 0..100 (width), y = 0..100 (height). y high = own goal (bottom).
export const FORMATIONS = {
  "4-3-3": [
    { x: 50, y: 90, pos: "GK" },
    { x: 15, y: 72 }, { x: 38, y: 76 }, { x: 62, y: 76 }, { x: 85, y: 72 },
    { x: 28, y: 52 }, { x: 50, y: 50 }, { x: 72, y: 52 },
    { x: 22, y: 25 }, { x: 50, y: 20 }, { x: 78, y: 25 },
  ],
  "4-4-2": [
    { x: 50, y: 90, pos: "GK" },
    { x: 15, y: 72 }, { x: 38, y: 76 }, { x: 62, y: 76 }, { x: 85, y: 72 },
    { x: 15, y: 50 }, { x: 38, y: 52 }, { x: 62, y: 52 }, { x: 85, y: 50 },
    { x: 38, y: 24 }, { x: 62, y: 24 },
  ],
  "3-5-2": [
    { x: 50, y: 90, pos: "GK" },
    { x: 28, y: 76 }, { x: 50, y: 78 }, { x: 72, y: 76 },
    { x: 12, y: 54 }, { x: 33, y: 52 }, { x: 50, y: 56 }, { x: 67, y: 52 }, { x: 88, y: 54 },
    { x: 38, y: 24 }, { x: 62, y: 24 },
  ],
  "4-2-3-1": [
    { x: 50, y: 90, pos: "GK" },
    { x: 15, y: 72 }, { x: 38, y: 76 }, { x: 62, y: 76 }, { x: 85, y: 72 },
    { x: 35, y: 60 }, { x: 65, y: 60 },
    { x: 22, y: 40 }, { x: 50, y: 38 }, { x: 78, y: 40 },
    { x: 50, y: 20 },
  ],
  "5-3-2": [
    { x: 50, y: 90, pos: "GK" },
    { x: 10, y: 70 }, { x: 30, y: 76 }, { x: 50, y: 78 }, { x: 70, y: 76 }, { x: 90, y: 70 },
    { x: 28, y: 52 }, { x: 50, y: 50 }, { x: 72, y: 52 },
    { x: 38, y: 25 }, { x: 62, y: 25 },
  ],
};

export const DRAW_COLORS = [
  { key: "gold", value: "#f59e0b" },
  { key: "cyan", value: "#06b6d4" },
  { key: "white", value: "#ffffff" },
  { key: "danger", value: "#ef4444" },
];
